import { createQueryKeys, mergeQueryKeys } from "@lukemorales/query-key-factory";
import { fetchLoginICafeInfo } from "@features/auth/api/loginApi";

const loginICafeInfo = createQueryKeys("loginICafeInfo", {
  info: (iCafeId: string) => {
    return {
      queryKey: [iCafeId],
      queryFn: ({ signal }) => fetchLoginICafeInfo(iCafeId, signal), // axios 요청도 중단할 수 있도록 signal 보내야 함
    };
  },
});

export const loginQueryKeys = mergeQueryKeys(loginICafeInfo);
